<template>
  <div class="open-browser-cover"
       @click="closeModule()"
       v-show="show"
  >
    <img :src="img[hintType]" alt="提示">
  </div>
</template>

<script>
import utils from "../../jslib/utils"

export default {
  name: "cover",
  props: {
    type:{
      type: String,
      default: 'openBrowser'  // ["openBrowser" | "shareToFriends"]
    },
    show: {                   // 遮罩
      type: Boolean,
      default: false
    },
  },
  data(){
    return{
      hintType: this.type,
      img:{
        openBrowser: require('./../../assets/img/group_coupon/open_browser.png'),
        shareToFriends: require('./../../assets/img/group_coupon/share_to_fiends.png')
      }
    }
  },
  methods:{

    closeModule(){
      this.$emit('update:show', !this.show)
    },

    showModule(){
      this.$emit('update:show', true)
    },

    /**
     * 打开APP, 没有就下载
     * @param {String<Number> | Number | Boolean} isInside - 是否是APP内部页
     * @param {String} path=['event'|'groupDetail'|'main'] - APP页面 [活动页|券团详情页|app首页]
     * @param {boolean} wechatToBrowser - 是否微信内引导到浏览器 默认true
     * @param {String} hintType=["openBrowser" | "shareToFriends"] - 提示打开浏览器还是分享给朋友 默认openBrowser
     * */
    openApp(isInside=utils.getPlatform().mfhApp, path='main', wechatToBrowser=true, hintType='openBrowser') {

      this.hintType = hintType

      if(utils.getPlatform().weChat){    // 对微信端的操作

        isInside = 0

        // 打开“去浏览器操作”提醒
        if(wechatToBrowser){
          this.showModule()
          return true
        }

        return false                  // 微信内不打开APP 直接进行下一步操作
      }

      isInside = +isInside

      console.log(utils.getPlatform())

      if (isInside) return false

      this.arouseApp(path)  // 打开APP

      setTimeout(()=>{
        this.$uihelper.toast('您还未下载APP')
      }, 1000)

      setTimeout(()=>{
        location.href = 'https://www.yidaocube.com'
      }, 1500)

      return true
    },

    arouseApp(path){
      let scheme
      let fullPath = location.href

      let param = ''

      if(path === 'event'){
        let url = utils.updateUrlQS(fullPath, 'is_mine', '0')
        url = utils.updateUrlQS(url, 'is_inside', '1')
        url = encodeURIComponent(url)

        let activity_id_param = '&activity_id=' + utils.getURLQueryString(fullPath,'activity_id')
        param = `&url=${url}` + (activity_id_param || '')
      }

      switch (utils.getEnv()){
        case 'web':
          break
        case 'android':
          scheme = 'scheme://mofanghouse:8080/init'
          location.href = `${scheme}?path=${path}` + param
          break
        case 'ios':
          scheme = 'h5-mofanghouse://init'
          location.href = `${scheme}?path=${path}` + param
          break
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.open-browser-cover{
  position: fixed;
  top: 0;
  left: 0;
  background-color: #000;
  opacity: .9;
  width: 100vw;
  height: 100vh;
  user-select: none;
  z-index: 1;
  img{
    position: absolute;
    right: .5rem;
    top: .7rem;
    opacity: 1;
    width: 5rem;
  }
}
</style>
